export const MAX_DOCUMENT_MB = 25;
const MIMES = {
  pdf: 'application/pdf', doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png',
  jfif: 'image/jpeg', webp: 'image/webp', gif: 'image/gif', bmp: 'image/bmp',
  tif: 'image/tiff', tiff: 'image/tiff', heic: 'image/heic', heif: 'image/heif', avif: 'image/avif',
  odt: 'application/vnd.oasis.opendocument.text', rtf: 'application/rtf', txt: 'text/plain', csv: 'text/csv',
  xls: 'application/vnd.ms-excel', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ods: 'application/vnd.oasis.opendocument.spreadsheet', ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', odp: 'application/vnd.oasis.opendocument.presentation',
  pages: 'application/vnd.apple.pages', numbers: 'application/vnd.apple.numbers', key: 'application/vnd.apple.keynote',
};
const ALL = Object.keys(MIMES);
export const PREVIEW_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'jfif', 'png', 'gif', 'webp', 'bmp', 'avif'];

export const documentExtension = (file) => {
  const name = file.name.trim();
  if (name.includes('.')) return name.split('.').pop().toLowerCase();
  return Object.keys(MIMES).find(ext => MIMES[ext] === file.type.toLowerCase()) || '';
};

export const DOCUMENT_FIELDS = [
  { type: 'cv', label: 'checkCv', field: 'cv_url', extensions: ALL, recommended: true },
  { type: 'cover-letter', label: 'coverLetter', field: 'cover_letter_url', extensions: ALL },
  { type: 'id-card', label: 'idCard', field: 'id_card_url', extensions: ALL },
  { type: 'recognition-certificate', label: 'recognitionCertificate', field: 'recognition_certificate_url', extensions: ALL },
  { type: 'certificate', label: 'certificates', field: 'certificates_urls', responseField: 'certificate_url', extensions: ALL, multiple: true },
  { type: 'document', label: 'otherDocuments', field: 'other_documents_urls', responseField: 'document_url', extensions: ALL, multiple: true },
];

export const acceptedFiles = (extensions) => [...new Set(extensions.flatMap(ext => [`.${ext}`, MIMES[ext]]))].join(',');

export const validateDocument = (file, extensions) => {
  if (file.size === 0) return 'empty_file';
  if (file.size > MAX_DOCUMENT_MB * 1024 * 1024) return 'file_too_large';
  if (!extensions.includes(documentExtension(file))) return 'unsupported_type';
  return null;
};

export const documentErrorCode = (error) => {
  if (!error.response) return 'network';
  if (error.response.status === 401) return 'session';
  if (error.response.status === 413) return 'file_too_large';
  const code = error.response.data?.detail?.code;
  return ['empty_file', 'file_too_large', 'unsupported_type', 'invalid_content'].includes(code) ? code : 'failed';
};